// components/SeoSchema.js
import Head from 'next/head'

export default function SeoSchema({ title, description, url, image }) {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": title,
    "description": description,
    "url": url,
    "image": image,
    "brand": {
      "@type": "Brand",
      "name": "iLovePDFTools"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "0.00",
      "availability": "https://schema.org/InStock"
    }
  }

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaData)
        }}
      />
    </Head>
  )
}
